import PropTypes from "prop-types";
import React, { useState } from "react";

const Mp3Audio = ({ src, name, attributes, isFocused }) => {
  const [maskLifted, setMaskLifted] = useState(false);

  const keepEventInPlayer = (event) => {
    event.stopPropagation();
  };

  const liftMask = () => {
    setMaskLifted(true);
  };

  const seedNativeDragData = (event) => {
    event.dataTransfer.setData("text/plain", name || "audio");
  };

  return (
    <div
      {...attributes}
      style={{
        position: "relative",
        display: "inline-block",
        padding: "8px",
        outline: isFocused ? "2px solid blue" : "none",
      }}
      draggable
      onDragStart={seedNativeDragData}
    >
      {name && (
        <span
          style={{
            display: "block",
            margin: "0 0 4px 0",
            fontSize: "12px",
          }}
        >
          {name}
        </span>
      )}
      <audio
        controls
        src={src}
        style={{
          display: "block",
          width: "300px",
        }}
        onMouseDown={keepEventInPlayer}
        onClick={keepEventInPlayer}
        onKeyDown={keepEventInPlayer}
      />
      <div
        style={{
          display: maskLifted ? "none" : "block",
          position: "absolute",
          top: "0",
          left: "0",
          height: "100%",
          width: "100%",
          cursor: "cell",
          zIndex: 1,
        }}
        onClick={liftMask}
      />
    </div>
  );
};

Mp3Audio.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  attributes: PropTypes.object.isRequired,
  isFocused: PropTypes.bool.isRequired,
};

export default Mp3Audio;
